import React from "react";
import { FaFileInvoice, FaFileUpload, FaPlay, FaTruck, FaChartPie, FaRegTimesCircle } from "react-icons/fa";
import "./TallyFieldPage.css";

const InvoiceFeatureList = () => {
  const features = [
    {
      title: "Instant e-Invoices",
      content: "Generate e-invoices instantly with zero manual intervention. Automatically create JSON files and QR codes for seamless compliance.",
      icon: <FaFileInvoice />,
    },
    {
      title: "Bulk e-Invoicing",
      content: "Effortlessly handle high-volume billing. TallyPrime's bulk feature lets you generate and maintain thousands of e-invoices in seconds.",
      icon: <FaFileUpload />,
    },
    {
      title: "Live Product Demo",
      content: "Experience the power of automated compliance. Try our instant demo to explore the seamless e-invoicing workflow.",
      icon: <FaPlay />,
    },
    {
      title: "e-Way Bill Integration",
      content: "Generate e-way bills simultaneously with your e-invoices. Eliminate redundant manual entries and save valuable time.",
      icon: <FaTruck />,
    },
    {
      title: "Compliance Reports",
      content: "Access accurate reports of your e-invoice status. Monitor pending, successful, and filed reports in a single dashboard.",
      icon: <FaChartPie />,
    },
    {
      title: "Direct Cancellation",
      content: "Made a mistake? Cancel e-invoices directly from the software, ensuring your GST records remain accurate and up-to-date.",
      icon: <FaRegTimesCircle />,
    },
  ];

  return (
    <div className="tally-field-page">
      <div className="tally-field-container">
        <header className="tally-field-header">
          <span className="subtitle">Core Feature</span>
          <h1>e-Invoicing Made Simple</h1>
          <p>Automate your GST compliance with built-in e-invoicing and e-way bill generation.</p>
        </header>

        <div className="tally-field-grid">
          {features.map((feature, index) => (
            <div className="tally-field-card" key={index}>
              <div className="icon-wrapper">
                {feature.icon}
              </div>
              <div className="card-content">
                <h3>{feature.title}</h3>
                <p>{feature.content}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InvoiceFeatureList;
